export const MEDIUM_SCREEN_WIDTH = 1100;
export const MOBILE_SCREEN_WIDTH = 768;
export const SMALL_MOBILE_SCREEN_WIDTH = 576;


// WEBPACK FOOTER //
// ./src/common/MobileUtils.js